export const reportRouter = [
  {
    path: "report",
    name: "report",
    component: () => import("../pages/report/restaurant/ReportPage.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.restaurant",
      parent: {
        name: "$vuetify.layout.navigationSidebar.report",
        disabled: false,
      },
    },
  },
];
